/* @ngInject */
export default function appRun() {}
